var map = {
	"./google-play-badge-da-DK.svg": 1392,
	"./google-play-badge-de-DE.svg": 74594,
	"./google-play-badge-en-GB.svg": 20368,
	"./google-play-badge-en-US.svg": 39019,
	"./google-play-badge-es-ES.svg": 48364,
	"./google-play-badge-es-MX.svg": 9871,
	"./google-play-badge-fr-FR.svg": 72564,
	"./google-play-badge-it-IT.svg": 83786,
	"./google-play-badge-nb-NO.svg": 87465,
	"./google-play-badge-nl-NL.svg": 21392,
	"./google-play-badge-pl-PL.svg": 44648,
	"./google-play-badge-pt-BR.svg": 23092,
	"./google-play-badge-pt-PT.svg": 96056,
	"./google-play-badge-sv-SE.svg": 6457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;